import * as React from 'react';

interface HybridModeIconProps {
    size?: number;
    color?: string;
}

const HybridModeIcon: React.FC<HybridModeIconProps> = ({ size = 16, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
        <rect x="1.86328" y="1.86328" width="16.2744" height="16.2744" rx="1.25" stroke={color} strokeWidth="1.5" />
        <path d="M7.25 2.06738L8.75 2.06738L8.75 18.0879L7.25 18.0879L7.25 2.06738Z" fill={color} />
        <path d="M8.75 4.32813V5.82813L1.98926 5.82812L1.98926 4.32812L8.75 4.32813Z" fill={color} />
        <path d="M8.75 14.3271V15.8271L1.98926 15.8271L1.98926 14.3271L8.75 14.3271Z" fill={color} />
        <path d="M8.75 10.9941V12.4941L1.98926 12.4941L1.98926 10.9941L8.75 10.9941Z" fill={color} />
        <path d="M8.75 7.66113V9.16113L1.98926 9.16113L1.98926 7.66113L8.75 7.66113Z" fill={color} />
    </svg>
);

export default HybridModeIcon;
